import { Box, Divider, Grid, Paper, Typography, Chip, Modal, IconButton, TextField, InputAdornment, Avatar } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useStyles } from '../styles';
import Images from '../../../Assets/assetHelper';
import KenColors from '../../../Helpers/Themes/kenColors';
import { AppButton } from '../../../Components/AppButton';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { announcementCardsData } from '../components/dummyData/announcementCardsData';
import AnnouncementCard from '../components/AnnouncementCard';
import { useSnackbar } from 'notistack';
import KenDialog from '../../../GlobalComponents/KenDialog';
import ChatBox from '../../../GlobalComponents/ChatBox';
import CreatePostModal from '../CreatePostModal';
import { getGroupEnrollmentDetail, GetlastMessage, groupEnrollment, LeftGroups } from '../../../Utils/apiService';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from "date-fns";
import { enGB } from "date-fns/locale";
import KenLoader from '../../../GlobalComponents/KenLoader';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

const YourGroupsDetails = () => {
  const classes: any = useStyles();
  const {
    state: { user } } = useContext(AuthContext);
  const userData = user as AuthUser;
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const groupId = searchParams.get("id");
  const [chatid, setchatid] = useState('')
  const pathSegments = location.pathname.split("/");
  const groupName = decodeURIComponent(pathSegments[pathSegments.length - 1]);
  const [loading, setLoading] = useState(false);
  const [groupEnrollmentData, setGroupEnrollmentData] = useState<any>(null);
  const [memberlist, setMemberlist] = useState<any>([]);
  const [membersSearchTerm, setMembersSearchTerm] = useState('');
  const [openMember, setOpenMember] = useState(false);
  const handleCloseviewMenber = () => setOpenMember(false);
  const handleOpenviewMenber = () => setOpenMember(true);

  const filteredMembersData = memberlist
    .filter((item: any) => item.Alumni_Member__r && item.Alumni_Member__r.Name && item.Alumni_Member__r.Name.toLowerCase().includes(membersSearchTerm.toLowerCase()))
    .map((item: any) => ({
      name: item.Alumni_Member__r?.Name || 'Unknown',
      img: item.Alumni_Member__r?.Profile_Picture_URL__c || '',
    }));

  console.log(groupEnrollmentData, "groupEnrollmentData");

  const data = {
    name: groupName,
    id: groupId,
    chatid: chatid,
    coverImage: groupEnrollmentData?.Cover_Image_Url__c
  }
  const { enqueueSnackbar } = useSnackbar();
  const [joinedGroup, setjoinedGroup] = useState<boolean>(false);
  const [cancelRegistration, setCancelRegistration] = useState<boolean>(false);
  const [isChatBoxOpen, setChatBoxOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [LeftGroupId, setLeftGroupId] = useState<string>('')
  const formatDate = (dateString: string) => {
    if (!dateString) return "N/A"; // Handle cases where date is null
    const date = new Date(dateString);
    return format(date, "dd MMM yyyy", { locale: enGB }); // Formats like "12 Jun 2022"
  };

  useEffect(() => {
    setLoading(true);

    if (groupId) {
      getGroupEnrollmentDetail(userData?.applicantId, groupId).then((res) => {
        setGroupEnrollmentData(res?.data?.data?.groupDetails);
        setLeftGroupId(res?.data?.data?.enrollmentDetails?.Id)
        setMemberlist(res?.data?.data?.groupDetails?.Group_Members__r?.records);
        if (res?.data?.data?.enrollmentDetails === null) {
          setjoinedGroup(false)
          setLoading(false);
        }
        else {
          if (res?.data?.data?.enrollmentDetails?.isActive__c == true) {
            setjoinedGroup(true)
            setchatid(res?.data?.data?.groupDetails?.ChatRoomId__c)
            setLoading(false);
          }
          else {
            setjoinedGroup(false)
            setLoading(false);
          }
        }
      });
    }
  }, [])
  const handleOpenMessage = () => {
    setChatBoxOpen(true);
  };

  const handleChatBoxClose = () => {
    setChatBoxOpen(false);
  };

  const handleOpenLeaveGroup: () => void = () => {
    setCancelRegistration(!cancelRegistration);

  };

  const handleLeaveGroup = () => {
    LeftGroups(LeftGroupId).then((res) => {
      if (res?.success == true) {
        const message = (
          <Box>
            <Typography sx={{ fontSize: '16px', fontWeight: '600', lineHeight: '22px' }}>Left the group successfully !</Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '22px' }}>You have left the {groupName}</Typography>
          </Box>
        );
        enqueueSnackbar(message, { variant: 'success', autoHideDuration: 1000 });
        setCancelRegistration(!cancelRegistration);
        navigate(`/groups/discover-groups/${groupName}?id=${groupId}`);
      }
      else {
        enqueueSnackbar("Unable to process your request at the moment. Please check your connection and try again.", {
          variant: "error",
          autoHideDuration: 1000
        });
        setCancelRegistration(!cancelRegistration);
        setjoinedGroup(true)
      }
    })

    setjoinedGroup(false);
  };
  useEffect(() => {
    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      navigate("/groups/your-groups");
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);
  const [lastMessage, setLastMessage] = useState<any>(null);
  console.log(lastMessage, "lastMessage12343234");
  
  useEffect(() => {
    if (chatid) {
      GetlastMessage(chatid).then((res: any) => {
        const message = res?.data?.data[0]?.lastMessage?.timestamp;
        setLastMessage(message);
      });
    }
  }, [chatid]);
  const formatTimeAgo = (timestamp: number) => {
    const now = Date.now(); // Current local time in milliseconds
    const diff = Math.floor((now - timestamp) / 1000); // Difference in seconds
  
    if (diff < 60) return `${diff} sec ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    return `${Math.floor(diff / 86400)} days ago`;
  };
  return (
    <>
      {loading && <KenLoader />}
      <KenDialog
        maxWidth={'500px'}
        open={cancelRegistration}
        handleClose={handleOpenLeaveGroup}
        hidePositiveButton={true}
        dialogActions={true}
        positiveButtonClick={handleLeaveGroup}
        hideNegativeButton={false}
        negativeButtonText={"No, don't leave"}
        negativeButtonClick={handleOpenLeaveGroup}
        hideCustomPositiveButton={false}
        customPositiveButtonText="Yes"
        customPositiveButtonStyle={classes.customPositiveButtonStyle}
      >
        <Typography sx={{
           '@media (max-width:626px)': {
            width: '100% !important',
          },
        }} fontSize={'15px'} width={'500px'} whiteSpace={'wrap'}>
          Are you sure your want to leave the group?
        </Typography>
      </KenDialog>
      <Grid item container>
        <Paper className={`${classes.paperCustom} scrollbar-cusgrayHeader`} sx={{ height: '83.5vh' }}>
          <Grid container spacing={{ xs: 1, md: 6 }}>
            <Grid item xs={12}>
              <Box className={classes.groupTagContainer}>
                {groupEnrollmentData?.Tags__c ?
                  <Chip
                    label={groupEnrollmentData?.Tags__c ? groupEnrollmentData?.Tags__c : null}
                    size="small"
                    sx={{
                      backgroundColor: '#BFCEFF',
                      color: '#1A358C',
                      padding: '3px 9px 3px 9px',
                      height: '27px',
                      '& .MuiChip-label': {
                        fontSize: '12px',
                        fontWeight: '500',
                        padding: '3px 9px 3px 9px',
                      },
                    }}
                  />
                  : null}
                
              </Box>
            </Grid>
            <Grid item lg={4} xs={12}>
              <img src={groupEnrollmentData?.Cover_Image_Url__c ? groupEnrollmentData?.Cover_Image_Url__c : Images.Images.entreprenursOfKen42} alt={'Entrepeneurs of Ken42'} className={classes.eventBanner} />
            </Grid>
            <Grid item lg={4.5} xs={12}>
              <Box className={classes.boxContainer1}>
                <Typography className={classes.aboutTheGroupContainerHeaderTypo}>About the Group</Typography>
                <Typography className={classes.subTypo} marginTop={'12px'}>
                  {groupEnrollmentData?.Description__c}
                </Typography>
              </Box>
            </Grid>
            <Grid item lg={3} xs={12}>
              <Box className={classes.boxContainer1}>
                <Typography className={classes.aboutTheGroupContainerHeaderTypo} marginBottom={'12px'}>
                  Rules of the Group
                </Typography>
                {groupEnrollmentData?.Group_Rules__c?.split(";").map((rule: string, index: number) => (
                  <Box className={classes.boxContainer2} sx={{ marginBottom: { xs: '8px', md: '10px' } }}>
                    <Box key={index} className={classes.boxContainer2} sx={{ marginBottom: { xs: '8px', md: '10px' } }}>
                      <img src={Images.Icons.Check} alt="" />
                      <Typography className={classes.subTypo}>{rule}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Divider color={KenColors.ClientBlue4} />
              <Box className={classes.boxContainer3}>
                <Box>
                  <Box className={classes.boxContainer4}>
                    <Typography className={classes.activeTypo}>Last active: {formatTimeAgo(lastMessage)}</Typography>
                    <Box className={classes.activityContainer} style={{cursor:"pointer"}} onClick={handleOpenviewMenber}>
                      <PeopleAltOutlinedIcon />
                      <Typography className={classes.activeTypo}> {groupEnrollmentData?.Member_Count__c ? groupEnrollmentData?.Member_Count__c : '-'}</Typography>
                    </Box>
                  </Box>
                  <Typography className={classes.activeTypo} sx={{ color: KenColors.ClientGrey, marginTop: '8px' }}>
                    Started on: {formatDate(groupEnrollmentData?.CreatedDate)}
                  </Typography>
                </Box>

                {joinedGroup ? (
                  <Box className={classes.joinedGroupContainer}>
                    {/* <Typography sx={{ color: '#5981FF', fontSize: '12px', fontWeight: 500, mt: 1, mr: 2, cursor: 'pointer' }} onClick={handleOpen}>
                      Create new post
                    </Typography> */}
                    <Modal open={open} onClose={(_, reason) => reason !== "backdropClick" &&handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                      <CreatePostModal handleClose={handleClose} />
                    </Modal>
                    <AppButton size="large" className={classes.appButtonMessage} onClick={handleOpenMessage}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Message</Typography>
                    </AppButton>
                    <AppButton
                      size="large"
                      className={classes.appButtonLeave}
                      onClick={() => {
                        handleOpenLeaveGroup();
                      }}
                    >
                      <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Leave Group</Typography>
                    </AppButton>
                  </Box>
                ) : (
                  <AppButton
                    size="large"
                    sx={{
                      backgroundColor: '#f5b004',
                      color: 'black',
                      '&:hover': {
                        backgroundColor: '#d49a03' // Darker yellow on hover
                      }
                    }}
                  >
                    <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                      Pending for Approval
                    </Typography>
                  </AppButton>

                )}
              </Box>
            </Grid>
            {/* <Grid container item xs={12} spacing={2}>
              {announcementCardsData.map((data, index) => {
                return (
                  <Grid item key={index} xs={12} md={5.5}>
                    <AnnouncementCard data={data} CardFor="Detail" />{' '}
                  </Grid>
                );
              })}
            </Grid> */}
          </Grid>
        </Paper>
      </Grid>
      {isChatBoxOpen && <ChatBox onClose={handleChatBoxClose} mentordetails={data} name={groupName} avatarImg={Images.Images.entreprenursOfKen42} />}
      <Modal open={openMember} onClose={handleCloseviewMenber}>
        <Box
          sx={{
            width: 400,
            bgcolor: 'white',
            p: 2,
            borderRadius: 2,
            mx: 'auto',
            my: '10%',
            boxShadow: 24,
            maxHeight: '80vh',
            overflow: 'hidden',
            '@media (max-width:626px)': {
              width: '90%',
              height: '90%'
            },
          }}
        >
          {/* Header */}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography fontSize={14} fontWeight={500}>Members</Typography>
            <IconButton onClick={handleCloseviewMenber} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ my: 1 }} />

          {/* Search Bar */}
          <TextField
            placeholder="Search"
            fullWidth
            size="small"
            variant="outlined"
            value={membersSearchTerm}
            onChange={(e) => setMembersSearchTerm(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          {/* Scrollable User List */}
          <Box
            sx={{
              overflowY: 'auto',
              maxHeight: 'calc(80vh - 130px)',
              pr: 1,
              '&::-webkit-scrollbar': {
                width: 0,
              },
              '-ms-overflow-style': 'none',
              scrollbarWidth: 'none',
            }}
          >
            {filteredMembersData.map((user: { img: string | undefined; name: string }, index: number) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={1.2}
                borderRadius={2}
                mb={1}
                sx={{ bgcolor: '#F6F8FB' }}
              >
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Avatar src={user.img} />
                  <Typography fontSize={14} fontWeight={500}>{user.name}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default YourGroupsDetails;
